import Api from "./Api";
const prefix = "alerts/";
export default {
  alertsPopups() {
    return Api().get(prefix + "alertsPopups");
  },
  alerts() {
    return Api().get("alerts");
  },
  lastAlert() {
    return Api().get(prefix + "lastAlert");
  },
  popupBycust(obj) {
    return Api().get(prefix + "popupBycust", { params: obj });
  },
  approvePopUp(obj) {
    return Api().post(prefix + "approvePopUp", obj);
  },
  promotions() {
    return Api().get(prefix + "promotions");
  },
  savePromotion(obj) {
    return Api().post(prefix + "savePromotion", { promotion: obj });
  },
  removePromotion(promo) {
    return Api().post(prefix + "removePromotion", { promo: promo });
  },
  saveAlert(obj) {
    return Api().post(prefix + "saveAlert", { alert: obj });
  },
  removeAlert(alert) {
    return Api().post(prefix + "removeAlert", { alert: alert });
  },
  saveSubscriber(subObj) {
    return Api().post(prefix + "saveSubscriber", subObj);
  },
  removeSubscriber() {
    return Api().get(prefix + "removeSubscriber");
  },
};
